var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLowerJ(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 57,
    viewBox: "0 0 14 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9 8.77H12.29V38.72C12.29 42.18 11.84 45.44 10.95 48.13C9.93 51.33 7.94 53.95 5.57 55.36C4.16 56.19 2.5 56.7 0.26 56.77L0 53.44C1.79 53.31 2.88 52.99 3.84 52.42C5.5 51.46 6.85 49.54 7.68 47.04C8.45 44.67 8.9 41.79 8.9 38.72V8.77ZM13.57 2.75C13.57 4.16 12.23 5.5 10.82 5.5C9.41 5.5 8.07 4.16 8.07 2.75C8.07 1.34 9.41 0 10.82 0C12.23 0 13.57 1.34 13.57 2.75Z",
    fill: "#949494"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowerJ);
export default __webpack_public_path__ + "static/media/LOWER_J.7f1655a3852bbfb86423c461d968c7a0.svg";
export { ForwardRef as ReactComponent };